<ng-container *ngIf="false && isDemoProject === false">

  <h4>Lets Get Started</h4>
  <p nz-typography
     nzType="secondary">
    Please follow the steps below to get started with Rapider. If you have any questions, please do not hesitate to
    contact us by using the <i class="fa-regular fa-circle-question"></i> icon in the top right corner.
  </p>
  <hr class="divider">
  <div class="onboarding-container">

    <div class="step-card">
      <nz-card>
        <h5 nz-typography
            class="onboarding-title">
          <i class="fa-regular fa-circle-1 fa-xl"></i> Connect A Datasource
        </h5>
        <p nz-typography
           nzType="secondary">
          Connect your business systems in seconds. Rapider AI will analyze your data and get ready to provide insights.
          Click here to add your first datasource.
        </p>
      </nz-card>

    </div>

    <div class="step-card">
      <nz-card>
        <h5 nz-typography
            class="onboarding-title">
          <i class="fa-regular fa-circle-2 fa-xl"></i> Ask a Question
        </h5>
        <p nz-typography
           nzType="secondary">
          Rapider's Analyst Agent finds the answer and suggests the smartest follow-up action. You stay in
          control and
          approve the next step.
        </p>
      </nz-card>
    </div>

    <div class="step-card">
      <nz-card>
        <h5 nz-typography
            class="onboarding-title">
          <i class="fa-regular fa-circle-3 fa-xl"></i> Build Your First Agent Workflow
        </h5>
        <p nz-typography
           nzType="secondary">
          Watch as Rapider securely moves data, updates records, and alerts your team across all your tools.
        </p>
      </nz-card>
    </div>

  </div>
</ng-container>
<ng-container *ngIf="isDemoProject === true">

  <!-- <section>
    <p>
      This is a demo workspace. You can ask questions about the demo data, but you cannot create or edit any
      entities. We have uploaded a sample dataset about the patients and lab results of a clinic. You can ask questions
      about this data to explore its structure and contents.
      <br>
      <button nz-button
              nzType="default"
              nz-tooltip="Click here to ask a sample question about the demo data"
              (click)="onDemoAskQuestionsButtonClicked()">
        Ask a sample question
      </button> &nbsp;
      <button nz-button
              nzType="default"
              nz-tooltip="Click here to create a new project"
              (click)="onDemoCreateProjectButtonClicked()">
        Create your workspace
      </button>
    </p>
  </section> -->

  <nz-alert class="demo-info container"
            nzType="info"
            nzCloseable="true"
            nzMessage="Welcome to the demo workspace. This is a public space where you can explore demo features."
            [nzDescription]="demoWorkspaceTemplate"
            nzShowIcon
            (nzOnClose)="onDemoWorkspaceAlertToggle($event)"></nz-alert>

</ng-container>

<ng-template #demoWorkspaceTemplate>
  <div class="demo-info-container"
       *ngIf="!demoAlertCollapsed">
    <p>
      You can ask questions about the demo data, but you cannot create or edit any
      entities on demo workspace. We have uploaded sample datasets about the patients and lab results of an imaginary
      clinic. You can ask questions
      about this data to explore its structure and contents. If you have any questions about Rapider, please do not
      hesitate to
      contact us by using the <i class="fa-regular fa-circle-question"></i> icon in the top right corner.

    </p>

    <div class="demo-buttons">
      <button *ngIf="tour !== 'nineth' && isDemoProject"
              nz-button
              nzType="default"
              (click)="onExploreClicked()">

          <i class="fa-regular fa-play"></i>&nbsp;Explore
        </button>
      <button nz-button
              nzType="default"
              [nz-tooltip]="hasAskedSampleQuestion ? 'Thank you for asking a sample question. Click here to ask another sample question.' :
              'Click here to ask a sample question about the demo data. Some sample questions are \'Who has high blood sugar?\', \'How many patients have diabetes?\' ...'
              "
              (click)="onDemoAskQuestionsButtonClicked()">

        <ng-container *ngIf="hasAskedSampleQuestion; else notAsked">
          <i class="fa-solid fa-circle-check"></i>&nbsp;Thank you for asking a sample question.
        </ng-container>
        <ng-template #notAsked>
          <i class="fa-regular fa-circle-1"></i>&nbsp;Ask a sample question
        </ng-template>

      </button>
      <button nz-button
              nzType="default"
              [nz-tooltip]="hasOwnProject ? 'Thank you for creating your workspace. Click here to navigate to list of your workspaces.' :
              'Click here to create your private workspace. You can connect your own data sources, invite your team members, and build your AI agents and workflows on your workspaces.'
              "
              (click)="onDemoCreateProjectButtonClicked()">
        <ng-container *ngIf="hasOwnProject; else notCreated">
          <i class="fa-solid fa-circle-check"></i>&nbsp;Thank you for creating your workspace.
        </ng-container>
        <ng-template #notCreated>
          <i class="fa-regular fa-circle-2"></i>&nbsp;Create your workspace
        </ng-template>
      </button>
    </div>


  </div>
</ng-template>
